export default function HeroSection() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative min-h-[90vh] md:min-h-screen flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/c43dd3b2b6fbcff1b6e6a251cdbd15c0/5634acacb550de41525b381ea3a37a19.png"
          alt="Phòng thí nghiệm vật liệu xây dựng"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#D4A017]/20 border border-[#D4A017]/50 text-[#D4A017] px-3 py-1 rounded-full text-xs md:text-sm font-medium mb-4 md:mb-5">
            <i className="ri-award-line"></i>
            Được cấp phép bởi Sở KH&amp;ĐT TP. Đà Nẵng
          </div>

          <h1 className="text-white font-bold leading-tight mb-3">
            <span className="block text-3xl md:text-4xl lg:text-5xl">PHÒNG THÍ NGHIỆM</span>
            <span className="block text-3xl md:text-4xl lg:text-5xl">VẬT LIỆU XÂY DỰNG</span>
            <span className="block text-xl md:text-2xl text-[#D4A017] mt-1.5 font-semibold italic">
              Uy tín – Chính xác – Nhanh chóng
            </span>
          </h1>

          <p className="text-white/80 text-sm md:text-base leading-relaxed mt-4 mb-6">
            Công ty TNHH Kỹ thuật Thuận Phát cung cấp dịch vụ thí nghiệm vật liệu xây dựng 
            chuyên nghiệp cho các công trình tại Đà Nẵng và khu vực miền Trung.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => handleNav("#services")}
              className="inline-flex items-center justify-center gap-2 bg-[#0E5C3A] text-white px-6 py-3 rounded-md font-semibold text-sm hover:bg-[#0A4A2E] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-flask-line"></i>
              Xem dịch vụ thí nghiệm
            </button>
            <button
              onClick={() => handleNav("#contact")}
              className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-6 py-3 rounded-md font-semibold text-sm hover:bg-white hover:text-[#0E5C3A] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              Liên hệ tư vấn
            </button>
          </div>

          {/* Công bố năng lực */}
          <div className="mt-4">
            <a
              href="https://sxd.danang.gov.vn/chi-tiet-tin-tuc?dinhdanh=771819&cat=685651"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#D4A017] text-white px-6 py-3 rounded-md font-semibold text-sm hover:bg-[#B8891A] transition-colors cursor-pointer"
            >
              <i className="ri-file-text-line"></i>
              GIẤY PHÉP CÔNG BỐ tại sở XÂY DỰNG tp ĐÀ NẴNG
            </a>
          </div>

          {/* Quick stats */}
          <div className="flex flex-wrap gap-5 mt-8 md:mt-10">
            {[
              { value: "5+", label: "Nhóm thí nghiệm" },
              { value: "2018", label: "Thành lập" },
              { value: "100+", label: "Loại thử nghiệm" },
              { value: "ĐN", label: "Trung tâm Đà Nẵng" },
            ].map((s) => (
              <div key={s.label} className="text-white">
                <div className="text-xl md:text-2xl font-bold text-[#D4A017]">{s.value}</div>
                <div className="text-xs text-white/70 mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll down indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/60 animate-bounce">
        <span className="text-xs">Cuộn xuống</span>
        <i className="ri-arrow-down-line text-lg"></i>
      </div>
    </section>
  );
}
